<template>
  <section class="finance-your-vehicle">
    <div class="container">
      <div class="row">
        <div class="col-sm-6">
          <h1>START YOUR VEHICLE BUYING PROCESS NOW!</h1>
          <h3>Our online finance application is fast, easy, and secure.</h3>
          <p>Auto Dealer is dedicated to delivering comprehensive and affordable financing options to drivers in City, State. Our <span>{{brandName}}</span> financing team is filled with knowledgeable professionals experienced in processing auto loans and leases. Each time one of our loyal customers is ready to begin their financing journey at Auto Dealer, they can count on finding a loan or lease option that works with their lifestyle and needs. Looking to put the <span>{{brandName}}</span>&nbsp;<a href="#">{{ images.sedans[0].modelName }}</a>, <a href="#">{{ images.suvs[0].modelName }}</a>, or <a href="#">{{ images.suvs[1].modelName }}</a> of your dreams in your driveway, on your terms? Fill out your finance application at Auto Dealer today!</p>
          <a class="finance-btn btn" href="#">APPLY NOW!</a>
        </div>
        <div class="col-sm-6 hidden-xs">
          <img class="img-responsive center-block" src="../../static/images/buy-a-car.jpeg">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.finance-your-vehicle {
  font-size: 16px;
  font-weight: 400;
  padding: 30px auto;
  background: #fff;
}
.finance-your-vehicle p a {
  color: var(--secondary-color);
  font-weight: 600;
  font-size: inherit !important;
  text-transform: none !important;
}
.finance-your-vehicle p a:hover {
  text-decoration: underline !important;
}
.finance-your-vehicle .finance-btn {
  color: #fff !important;
  background: var(--primary-color);
  font-size: 24px;
  padding: 10px 26px;
  margin: 15px auto;
  border-radius: 4px;
  box-shadow: 2px 13px 27px -10px #0F032C;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  transform: perspective(1px) translateZ(0);
  -webkit-transition-property: transform;
  transition-property: transform;
}
.finance-your-vehicle .finance-btn:hover {
  transform: scale(.97);
  box-shadow: 0px 5px 25px -4px #0F032C;
  text-decoration: none;
}
@media (max-width: 767px) {
  .finance-your-vehicle .finance-btn {
    display: block;
  }
}
</style>